import InlineVideo from './component'
export default InlineVideo
